export interface AppConfiguration {
  APP_URLS: string[];
  AUTH_SERVICE_URL: string;
  CLIENT_ID: string;
  IS_LOCAL_ENV: boolean;
  COPAS_URL: string;
  UNIFIED_COMMERCE_URL: string;
  EXT_ADMIN_SERVICE_URL: string;
  CLASSIC_PRODUCTS_URL: string;
  ADMIN_URL: string;
  COG_URL: string;
  ECOM_URLS: string[];
  SEGMENTS: {
    writeKey: string;
    disabled: boolean;
  };
  SENTRY_ENABLED: boolean;
}

export type Environments = 'local' | 'development' | 'rc' | 'staging' | 'production';

type AppConfig = {
  [key in Environments]: AppConfiguration;
};

const AppConfig: AppConfig = {
  local: {
    APP_URLS: ['http://localhost:3000'],
    AUTH_SERVICE_URL: 'https://authenticationed1.lmiinc.test.expertcity.com',
    CLIENT_ID: '18a8b25a-7678-4d8d-b371-2b19d6e44e09',
    IS_LOCAL_ENV: true,
    COPAS_URL: 'https://copas-apigateway.dev.purchase.goto.com',
    UNIFIED_COMMERCE_URL: 'https://commerceed.serversdev.getgo.com/unifiedcommerceservice',
    EXT_ADMIN_SERVICE_URL: 'https://iamed1.serversdev.getgo.com/ext-admin/rest',
    CLASSIC_PRODUCTS_URL: 'https://lmi.dev.3amlabs.net/Purchase/PurchaseGateway.aspx?success=1',
    ADMIN_URL: 'http://localhost:7099',
    COG_URL: 'https://lb0-ggc-gateway-ed-us-west-2.serversdev.getgo.com',
    ECOM_URLS: [
      'http://localhost:8080',
      'https://buydevcd.goto.com',
      'https://buydevcm.goto.com',
      'https://buydevcm.logmein.com',
    ],
    SEGMENTS: {
      writeKey: 'HHsgqopMJGONWKCutQLdhbmy1DOyFXZP',
      disabled: true,
    },
    SENTRY_ENABLED: false,
  },
  development: {
    APP_URLS: ['https://payments.ed.goto.com'],
    AUTH_SERVICE_URL: 'https://authenticationed1.lmiinc.test.expertcity.com',
    CLIENT_ID: '18a8b25a-7678-4d8d-b371-2b19d6e44e09',
    IS_LOCAL_ENV: false,
    COPAS_URL: 'https://copas-apigateway.dev.purchase.goto.com',
    UNIFIED_COMMERCE_URL: 'https://commerceed.serversdev.getgo.com/unifiedcommerceservice',
    EXT_ADMIN_SERVICE_URL: 'https://iamed1.serversdev.getgo.com/ext-admin/rest',
    CLASSIC_PRODUCTS_URL: 'https://lmi.dev.3amlabs.net/Purchase/PurchaseGateway.aspx?success=1',
    ADMIN_URL: 'https://admin.dev.gtc.goto.com',
    COG_URL: 'https://lb0-ggc-gateway-ed-us-west-2.serversdev.getgo.com',
    ECOM_URLS: [
      'http://localhost:8080',
      'https://buydevcd.goto.com',
      'https://buydevcm.goto.com',
      'https://buydevcm.logmein.com',
    ],
    SEGMENTS: {
      writeKey: 'HHsgqopMJGONWKCutQLdhbmy1DOyFXZP',
      disabled: false,
    },
    SENTRY_ENABLED: false,
  },
  rc: {
    APP_URLS: ['https://payments.rc.goto.com'],
    AUTH_SERVICE_URL: 'https://authenticationrc1.lmiinc.test.expertcity.com',
    CLIENT_ID: '62020fe8-c245-494e-a839-03a45f1cffa1',
    IS_LOCAL_ENV: false,
    COPAS_URL: 'https://api-copas.rc.purchase.goto.com',
    UNIFIED_COMMERCE_URL: 'https://commercerc.serversdev.getgo.com/unifiedcommerceservice',
    EXT_ADMIN_SERVICE_URL: 'https://iamrc1.serversdev.getgo.com/ext-admin/rest',
    CLASSIC_PRODUCTS_URL: 'https://lmirc.dev.3amlabs.net/Purchase/PurchaseGateway.aspx?success=1',
    COG_URL: 'https://lb0-ggc-gateway-rc-us-west-2.serversdev.getgo.com',
    ECOM_URLS: ['https://buyreview.goto.com', 'https://buyreview.logmein.com'],
    ADMIN_URL: '',
    SEGMENTS: {
      writeKey: '',
      disabled: true,
    },
    SENTRY_ENABLED: true,
  },
  staging: {
    APP_URLS: ['https://payments.stage.goto.com', 'https://payments.stage.logmein.com'],
    CLIENT_ID: 'dc2da939-22ad-4059-b908-85b5a63673e0',
    AUTH_SERVICE_URL: 'https://authenticationstage.logmeininc.com',
    IS_LOCAL_ENV: false,
    COPAS_URL: 'https://copas-apigateway.stage.purchase.goto.com',
    UNIFIED_COMMERCE_URL: 'https://commercestage.servers.getgo.com/unifiedcommerceservice',
    EXT_ADMIN_SERVICE_URL: 'https://iamstage.servers.getgo.com/ext-admin/rest',
    CLASSIC_PRODUCTS_URL: 'https://lmirc.dev.3amlabs.net/Purchase/PurchaseGateway.aspx?success=1',
    ADMIN_URL: 'https://admin.staging.gtc.goto.com',
    COG_URL: 'https://ggc-stage-us-east-1.servers.getgo.com',
    ECOM_URLS: ['https://buygamma.goto.com', 'https://buygamma.logmein.com'],
    SEGMENTS: {
      writeKey: '',
      disabled: true,
    },
    SENTRY_ENABLED: true,
  },
  production: {
    APP_URLS: ['https://payments.goto.com', 'https://payments.logmein.com'],
    AUTH_SERVICE_URL: 'https://authentication.logmeininc.com',
    CLIENT_ID: '61325a94-7f6f-422e-b901-1f6f2c06d3e7',
    ADMIN_URL: 'https://admin.goto.com',
    IS_LOCAL_ENV: false,
    COPAS_URL: 'https://copas-apigateway.purchase.goto.com',
    UNIFIED_COMMERCE_URL: 'https://commerce.servers.getgo.com/unifiedcommerceservice',
    EXT_ADMIN_SERVICE_URL: 'https://iam.servers.getgo.com/ext-admin/rest',
    CLASSIC_PRODUCTS_URL: 'https://secure.logmein.com/Purchase/PurchaseGateway.aspx?success=1',
    COG_URL: 'https://ggc-gateway-prod.servers.getgo.com',
    ECOM_URLS: [
      'https://buystaging.goto.com',
      'https://buy.goto.com',
      'https://buystaging.logmein.com',
      'https://buy.logmein.com',
    ],
    SEGMENTS: {
      writeKey: 'fg8PQIgZAx54oaM0nS0FfVcATwkD8y7h',
      disabled: false,
    },
    SENTRY_ENABLED: true,
  },
};

export default AppConfig;
